<template>
<div class="GJMIndex">
    <Header></Header>
    <div class="content_warp">
        <div class="top_box">
            <p class="p_title">基于大数据的股权设计专家</p>
            <p class="p_desc">标准化工具+专业咨询师=科学合理的股权方案<br/>更省时更省钱</p>
            <button @click="MessageBtn" class="btn">预约咨询</button>
        </div>

        <div class="warp1">
            <img class="img1" :src="require('@/common/images/gujingimgs/mindex/img1.png')" alt="">
        </div>
        <div class="warp2">
            <p class="title_text">为您提供相关产品服务</p>
            <div class="scheme_warp">
                <div class="scheme_item" v-for="(item, index) in schemeData" :key="index">
                    <img @click="toPageClick(item.name)" :src="item.imgUrl" alt="">
                </div>
            </div>
        </div>
        <div class="warp3">
            <img class="img2" :src="require('@/common/images/gujingimgs/mindex/img2.png')" alt="">
            <div class="content_div">
                <p class="title_text2">全面考虑方案设计核心要素</p>
                <p class="desc_text">华扬资本致力于为中小企业提供专业、贴身、精细化的资本运营服务，如IPO上市辅导、股权激励方案设计、股权融资、并购重组顾问等业务。<br/><br/>其中股权激励服务深得客户好评，凭借多年的实践经验，以独立第三方角度综合考虑员工和股东的利益，通过灵活的持股模式、科学的定量模型、有效的考核体系、动态的激励方式，为企业设计系统而有效的股权激励方案，并能很好地落地实施， 使股权激励真正成为企业做大做强的助推器。<br/><br/>股鲸是华扬资本旗下子品牌，专注在线股权设计服务，基于大数据和工具软件，加上专业咨询师辅助，让客户更省钱更省时的获取科学合理的股权方案。</p>
            </div>
        </div>
        <div class="warp4">
            <p class="title_text2">服务案例</p>
            <van-swipe :autoplay="3000">
                <van-swipe-item v-for="(image, index) in imgList1" :key="index">
                    <img class="swipe_img" v-lazy="image" />
                </van-swipe-item>
            </van-swipe>
        </div>
        <div class="warp5">
            <p class="title_text2">合作品牌</p>
            <van-swipe :autoplay="3000">
                <van-swipe-item v-for="(image, index) in imgList2" :key="index">
                    <img class="swipe_img" v-lazy="image" />
                </van-swipe-item>
            </van-swipe>
        </div>
        <div class="warp6">
            <p>联系我们，了解更多需求定制服务</p>
            <div @click="MessageBtn" class="btn_div">留言咨询</div>
        </div>
    </div>
    <Footer></Footer>
    <transition name="slide-fade">
        <img class="gotop_img" @click="goTop" v-show="show" :src="require('@/common/images/gujingimgs/go_top.png')" alt="">
    </transition>
</div>
</template>

<script>
import Header from 'views/gjMobile/components/Header'
import Footer from 'views/gjMobile/components/Footer'
import {mapGetters, mapActions} from 'vuex'
import $ from 'jquery'
export default {
    name: 'GJMIndex',
    data() {
        return {
            show: false,
            schemeData: [
                {
                    name: 'MEnterpriseEstimation',
                    imgUrl: require('@/common/images/gujingimgs/mindex/icon1.png')
                },
                {
                    name: 'MExcitation',
                    imgUrl: require('@/common/images/gujingimgs/mindex/icon2.png')
                },
                {
                    name: 'MEquityLearning',
                    imgUrl: require('@/common/images/gujingimgs/mindex/icon3.png')
                },
                {
                    name: 'MIndividualization',
                    imgUrl: require('@/common/images/gujingimgs/mindex/icon4.png')
                }
            ],
            imgList1: [
                require('@/common/images/gujing/index/imggroup.jpg'),
                require('@/common/images/gujing/index/slide_big.jpg')
            ],
            imgList2: [
                require('@/common/images/gujing/index/logo_list.png'),
                require('@/common/images/gujing/index/logo_list2.png'),
                require('@/common/images/gujing/index/logo_list3.png'),
                require('@/common/images/gujing/index/logo_list4.png')
            ]
        }
    },
    created() {
        // 判断是移动端还是PC端 并跳转到相应页面
        if(!this.domainInfo.isMobile){
            this.$router.push({
                name: 'GJIndex'
            })
        }
    },
    activated() {
        $('html,body').animate({scrollTop:'0px'},0)
    },
    mounted() {
        $('html,body').animate({scrollTop:'0px'},0)
        let _this = this
        $(window).scroll(function () {
            let scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
            let clientHeight = document.body.clientHeight / 2
            if(scrollTop >= clientHeight){
                _this.show = true
            }
            else{
                _this.show = false
            }
        })
    },
    methods: {
        // 留言咨询
        MessageBtn() {
            this.$router.push({name: 'Msg'})
        },
        // 页面跳转
        toPageClick(val) {
            this.$router.push({name: val})
        },
        // 回到顶部
        goTop() {
            $('html,body').animate({scrollTop:'0px'},300)
            // document.body.scrollTop = document.documentElement.scrollTop = 0;
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'user',
            'domainInfo'
        ])
    },
    components: {Header,Footer}
}
</script>

<style lang="scss" type="text/scss">
.GJMIndex {
    position: relative;
    background-color: #F5F7FA;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    font-family:PingFangSC-Medium,PingFang SC;
    .content_warp {
        flex: 1;
        // padding-bottom: 0.2rem;
        .top_box {
            height: 5.6rem;
            background: url('../../../common/images/gujingimgs/intro-bg.png') no-repeat center;
            background-size: 100% 100%;
            color: #FFF;
            padding: 0 0.32rem;
            padding-top: 1.6rem;
            box-sizing: border-box;
            .p_title {
                font-size: 0.48rem;
                line-height: 0.68rem;
                font-weight: bold;
            }
            .p_desc {
                margin: 0.4rem 0;
                font-size: 0.3rem;
                line-height: 0.46rem;
            }
            .btn {
                width: 2.2rem;
                height: 0.6rem;
                font-size: 0.28rem;
                background:linear-gradient(90deg,rgba(46,234,227,1) 0%,rgba(41,135,255,1) 100%);
                border: none;
                border-radius: 0.3rem;
            }
        }
        .title_text {
            position: relative;
            text-align: center;
            font-size: 0.36rem;
            line-height: 0.5rem;
            margin-bottom: 0.6rem;
            color: #333;
            font-weight: bold;
            &::before {
                content: '';
                position: absolute;
                margin: auto;
                bottom: -0.12rem;
                left: 0;
                right: 0;
                width:0.36rem;
                height:0.04rem;
                background: #409EFF;
            }
        }
        .title_text2 {
            position: relative;
            font-size: 0.36rem;
            line-height: 0.5rem;
            margin-bottom: 0.54rem;
            color: #333;
            font-weight: bold;
            &::before {
                content: '';
                position: absolute;
                margin: auto;
                bottom: -0.12rem;
                left: 0;
                width:0.36rem;
                height:0.04rem;
                background: #409EFF;
            }
        }
        .warp1 {
            background-color: #fff;
            .img1 {
                width: 100vw;
            }
            .template_img {
                width: 100%;
                margin-bottom: 0.4rem;
            }
            .tips_text {
                color: #999;
                font-size: 0.24rem;
                line-height: 0.34rem;
                text-align: center;
            }
        }
        .warp2 {
            background-color: #F5F7FA;
            padding: 0 0.24rem;
            padding-top: 0.5rem;
            .scheme_warp {
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
                .scheme_item {
                    width: 3.42rem;
                    height: 4.18rem;
                    margin-bottom: 0.4rem;
                    &>img {
                        width: 3.42rem;
                        height: 4.18rem;
                    }
                }
            }
        }
        .warp3 {
            background-color: #fff;
            .img2 {
                width: 100vw;
            }
            .content_div {
                padding: 0.48rem 0.32rem;
                .desc_text {
                    font-size: 0.28rem;
                    color: #666;
                    line-height: 0.52rem;
                }
            }
        }
        .warp4, .warp5 {
            padding: 0.48rem 0.32rem;
            padding-bottom: 0.16rem;
            background-color: #F5F7FA;
            .van-swipe {
                margin: 0 auto;
                height: 3.7rem;
                .swipe_img {
                    width: 6.86rem;
                    min-width: 6.86rem;
                    height: 3.02rem;
                    min-height: 3.02rem;
                }
            }
            .van-swipe__indicator {
                background-color: #666;
            }
            .van-swipe__indicator--active {
                background-color: #409EFF;
                opacity: 1;
            }
        }
        .warp5 {
            background-color: #fff;
            .van-swipe {
                height: 5rem;
                .swipe_img {
                    width: 6.86rem;
                    min-width: 6.86rem;
                    height: 4.38rem;
                    min-height: 4.38rem;
                }
            }
        }
        .warp6 {
            height: 4.54rem;
            background: url('../../../common/images/gujingimgs/bg1.png') no-repeat center;
            background-size: 100% 100%;
            color: #FFF;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            &>p {
                line-height: 0.54rem;
                font-size: 0.38rem;
                margin-bottom: 0.62rem;
            }
            .btn_div {
                border: 0.01rem solid #fff;
                box-sizing: border-box;
                font-size: 0.28rem;
                width: 2.2rem;
                height: 0.6rem;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 0.6rem;
            }
        }
    }
    .gotop_img {
        width: 1.16rem;
        height: 1.16rem;
        position: fixed;
        right: 0.2rem;
        bottom: 1rem;
        opacity: 1;
    }
}
.slide-fade-enter-active, .slide-fade-leave-active {
    transition: all .3s ease;
}
.slide-fade-enter, .slide-fade-leave-to{
    opacity: 0;
}
</style>